
import React from 'react';
import { 
  LayoutDashboard, 
  Users, 
  ShoppingCart, 
  Package, 
  Warehouse, 
  Layers, 
  GitCompare, 
  FileCheck, 
  ClipboardList,
  PlayCircle,
  Shield,
  LogOut,
  ArrowRightLeft,
  X,
  Bell,
  LayoutGrid,
  ChevronLeft,
  ChevronDown,
  Award,
  Gift,
  Clock,
  BrainCircuit,
  WalletCards,
  Building2,
  Users2,
  MessageSquare,
  CheckCircle2,
  MapPin,
  XCircle,
  FileText
} from 'lucide-react';
import { MenuItem } from '../types';
import { useStore } from '../context/StoreContext';
import { motion, AnimatePresence } from 'motion/react';
import { NavLink, useLocation } from 'react-router-dom';
import { AIChatDialog } from './AIChatDialog';

interface MenuCategory {
  id: string;
  label: string;
  icon: any;
  color?: string;
  items: MenuItem[];
}

const categories: MenuCategory[] = [
  {
    id: 'centers_group',
    label: 'مراكز وموظفين',
    icon: Users2,
    color: 'text-indigo-500 bg-indigo-50',
    items: [
      { id: 'centers_dashboard', label: 'إحصائيات المراكز العامة', icon: LayoutDashboard, permissionKey: 'viewCentersDashboard', color: 'text-indigo-600' },
      { id: 'agents', label: 'الوكلاءوالمراكز', icon: Users, permissionKey: 'viewAgents', color: 'text-blue-500' },
      { id: 'warehouse_locations', label: 'مواقع مخازن الوكلاء', icon: MapPin, permissionKey: 'viewWarehouseLocations', color: 'text-indigo-600' },
      { id: 'centers_system', label: 'سيستم المراكز', icon: LayoutGrid, permissionKey: 'viewCentersSystem', color: 'text-indigo-500' },
      { id: 'center_interface', label: 'واجهة المركز', icon: LayoutDashboard, permissionKey: 'viewCenterInterface', color: 'text-purple-500' },
      { id: 'cancelled_sales', label: 'فواتير الالغاء', icon: XCircle, permissionKey: 'viewCancelledSales', color: 'text-rose-500' },
      { id: 'employees', label: 'الموظفين', icon: Users, permissionKey: 'viewEmployees', color: 'text-emerald-500' },
      { id: 'complaints', label: 'الشكاوي والمدح', icon: MessageSquare, permissionKey: 'viewComplaints', color: 'text-rose-500' },
      { id: 'distinguished_users', label: 'المميزين', icon: Award, permissionKey: 'viewDistinguishedUsers', color: 'text-amber-500' },
      { id: 'attendance', label: 'سجل الحضور والإجازات', icon: Clock, permissionKey: 'viewAttendance', color: 'text-teal-500' },
      { id: 'company_letters', label: 'كتب الشركة', icon: FileText, permissionKey: 'viewCompanyLetters', color: 'text-indigo-600' },
      { id: 'users', label: 'المستخدمين والصلاحيات', icon: Shield, permissionKey: 'viewUsers', color: 'text-red-500' },
      { id: 'settings', label: 'إعدادات النظام', icon: GitCompare, permissionKey: 'manageSettings', color: 'text-slate-600' },
    ]
  },
  {
    id: 'accounts_group',
    label: 'الحسابات',
    icon: WalletCards,
    color: 'text-emerald-500 bg-emerald-50',
    items: [
      { id: 'accounts', label: 'لوحة تحكم الحسابات', icon: WalletCards, permissionKey: 'viewAccounts', color: 'text-emerald-600' },
      { id: 'commissions', label: 'سحوبات العمولات', icon: ShoppingCart, permissionKey: 'viewCommissions', color: 'text-teal-600' },
      { id: 'points', label: 'النقاط المؤجلة', icon: Clock, permissionKey: 'viewPoints', color: 'text-amber-500' },
      { id: 'exchange_rate', label: 'سعر الصرف', icon: ArrowRightLeft, permissionKey: 'manageExchangeRate', color: 'text-blue-500' },
      { id: 'offers', label: 'العروض', icon: Gift, permissionKey: 'viewOffers', color: 'text-fuchsia-500' },
    ]
  },
  {
    id: 'warehouses_group',
    label: 'المخازن',
    icon: Warehouse,
    color: 'text-amber-500 bg-amber-50',
    items: [
      { id: 'dashboard', label: 'لوحة تحكم المخازن', icon: LayoutDashboard, permissionKey: 'viewDashboard', color: 'text-primary-600' },
      { id: 'warehouses', label: 'المخازن العامة', icon: Warehouse, permissionKey: 'viewWarehousesDashboard', color: 'text-amber-600' },
      { id: 'products', label: 'الشحنات (المواد)', icon: Package, permissionKey: 'viewProducts', color: 'text-indigo-500' },
      { id: 'orders', label: 'الطلبات', icon: ShoppingCart, permissionKey: 'viewOrders', color: 'text-emerald-500' },
      { id: 'transfers', label: 'التحويلات المخزنية', icon: ArrowRightLeft, permissionKey: 'viewTransfers', color: 'text-orange-500' },
      { id: 'all_warehouses', label: 'المبيعات التقديرية', icon: Layers, permissionKey: 'viewAllWarehouses', color: 'text-purple-500' },
      { id: 'unified_sales', label: 'سجل المبيعات الموحد', icon: ClipboardList, permissionKey: 'viewUnifiedSales', color: 'text-indigo-600' },
      { id: 'product_sales_tracker', label: 'مبيعات منتج محدد', icon: ClipboardList, permissionKey: 'viewWarehousesDashboard', color: 'text-rose-500' },
      { id: 'approved_invoices', label: 'أرشيف المبيعات التقديرية', icon: FileCheck, permissionKey: 'viewApprovedInvoices', color: 'text-teal-500' },
      { id: 'system_match', label: 'مطابقة السيستم', icon: GitCompare, permissionKey: 'viewSystemMatch', color: 'text-indigo-500' },
      { id: 'match_invoices', label: 'فواتير مطابقة السيستم', icon: ClipboardList, permissionKey: 'viewMatchInvoices', color: 'text-rose-500' },
      { id: 'stock_forecasting', label: 'التنبؤ بالمخزون', icon: BrainCircuit, permissionKey: 'viewStockForecasting', color: 'text-fuchsia-500' },
    ]
  }
];

interface SidebarProps {
  activeTab: string;
  isOpen: boolean;
  onClose?: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ activeTab, isOpen, onClose }) => {
  const { currentUser, logout, fetchData, deferredPoints, systemSettings } = useStore();
  const [expandedCategory, setExpandedCategory] = React.useState<string | null>(null);
  const [isChatOpen, setIsChatOpen] = React.useState(false);

  const toggleCategory = (catId: string) => {
    setExpandedCategory(expandedCategory === catId ? null : catId);
  };

  return (
    <>
      <AnimatePresence>
        {isOpen && (
          <motion.div 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/40 z-[25] lg:hidden" 
            onClick={onClose}
          />
        )}
      </AnimatePresence>

      <aside className={`fixed top-0 right-0 h-full glass transition-all duration-200 z-[30] flex flex-col shadow-premium ${isOpen ? 'w-72 translate-x-0' : 'w-72 translate-x-full lg:translate-x-0'} border-l border-white/20 overflow-hidden`}>
        {/* Decorative Background Elements */}
        <div className="absolute top-0 left-0 w-full h-full pointer-events-none overflow-hidden opacity-20">
          <div className="absolute -top-24 -left-24 w-64 h-64 bg-primary-100 rounded-full blur-[100px]"></div>
          <div className="absolute top-1/2 -right-24 w-48 h-48 bg-indigo-100 rounded-full blur-[80px]"></div>
        </div>

        <div className="relative z-10 flex flex-col h-full bg-white/20">
          <div className="flex justify-between items-center p-5 lg:hidden">
            <h2 className="font-black text-lg tracking-tight text-slate-800">القائمة الرئيسية</h2>
            <button onClick={onClose} className="p-2 bg-white/40 hover:bg-white/60 text-slate-600 rounded-xl transition-all border border-white/40"><X size={20} /></button>
          </div>

          <div className="py-6 px-8 flex flex-col items-center justify-center relative group shrink-0">
            {systemSettings?.system_logo ? (
              <a 
                href="https://www.facebook.com/raedalkhair2u/" 
                target="_blank" 
                rel="no-referrer"
                className="w-full h-24 relative transition-all duration-500 hover:scale-105 group active:scale-95 flex items-center justify-center" 
                style={{ opacity: Number.isNaN(Number(systemSettings.system_logo_opacity)) ? 1 : (Number(systemSettings.system_logo_opacity) || 100) / 100 }}
              >
                 <div className="absolute inset-0 bg-primary-500/5 blur-3xl rounded-full scale-125 opacity-0 group-hover:opacity-100 transition-opacity"></div>
                 <img src={systemSettings.system_logo} alt="System Logo" className="h-full w-full object-contain relative z-10" />
              </a>
            ) : (
              <motion.div 
                whileHover={{ scale: 1.05 }}
                className="w-16 h-16 bg-slate-900 rounded-2xl flex items-center justify-center mb-0 shadow-xl border border-slate-800 relative overflow-hidden group"
              >
                <Package size={32} className="text-white relative z-10" strokeWidth={1.5} />
                <div className="absolute inset-0 bg-gradient-to-tr from-primary-600/20 to-transparent"></div>
              </motion.div>
            )}
          </div>

          <nav className="flex-1 overflow-y-auto px-4 py-2 no-scrollbar relative z-10">
            <div className="space-y-1.5">
              {categories.map((category) => {
                // Filter items based on permissions
                const visibleItems = category.items.filter(item => {
                  if (item.permissionKey && currentUser && !currentUser.permissions[item.permissionKey]) return false;
                  return true;
                });

                if (visibleItems.length === 0) return null;

                const isExpanded = expandedCategory === category.id;
                const containsActive = visibleItems.some(i => i.id === activeTab);

                return (
                  <div key={category.id} className="group/cat">
                    <button 
                      onClick={() => toggleCategory(category.id)}
                      className={`w-full flex items-center justify-between px-3.5 py-2.5 rounded-xl transition-all duration-300 border ${
                        isExpanded 
                          ? 'bg-slate-900 border-slate-900 shadow-lg shadow-slate-200 text-white' 
                          : 'bg-transparent border-transparent text-slate-500 hover:bg-slate-50 hover:text-slate-800'
                      }`}
                    >
                      <div className="flex items-center gap-2.5">
                        <div className={`p-1.5 rounded-lg transition-all duration-300 ${isExpanded || containsActive ? 'text-primary-500 bg-primary-50' : 'bg-slate-100 text-slate-400 group-hover/cat:bg-white group-hover/cat:text-slate-600'} ${isExpanded ? '!bg-white/10 !text-white' : ''}`}>
                          <category.icon size={16} strokeWidth={isExpanded ? 2 : 1.5} />
                        </div>
                        <span className={`font-bold text-[12px] tracking-tight ${isExpanded ? 'text-white' : ''}`}>{category.label}</span>
                      </div>
                      <ChevronDown 
                        size={14} 
                        className={`transition-transform duration-500 ${isExpanded ? 'rotate-180 opacity-100' : 'opacity-30'}`}
                      />
                    </button>

                    <AnimatePresence>
                      {isExpanded && (
                        <motion.ul 
                          initial={{ height: 0, opacity: 0 }}
                          animate={{ height: 'auto', opacity: 1 }}
                          exit={{ height: 0, opacity: 0 }}
                          className="overflow-hidden mt-1 mx-2 pr-6 relative space-y-1"
                        >
                           {/* Indicator Line */}
                           <div className="absolute right-3 top-0 bottom-4 w-px bg-gradient-to-b from-slate-200 via-slate-100 to-transparent rounded-full" />

                          {visibleItems.map((item) => {
                            const isPoints = item.id === 'points';
                            const totalDeferredPointsValue = isPoints ? deferredPoints.reduce((sum, p) => sum + Number(p.points || 0), 0) : 0;

                            return (
                              <li key={item.id}>
                                <NavLink 
                                  to={`/${item.id}`}
                                  onClick={() => { 
                                    if (onClose) onClose(); 
                                    
                                    const tableMap: Record<string, string> = {
                                      'centers_dashboard': 'agents',
                                      'warehouses_dashboard': 'products',
                                      'accounts_dashboard': 'expenses',
                                      'agents': 'agents',
                                      'orders': 'invoices',
                                      'transfers': 'transfers',
                                      'products': 'product_invoices',
                                      'warehouses': 'warehouses',
                                      'all_warehouses': 'approved_invoices',
                                      'system_match': 'match_invoices',
                                      'unified_sales': 'sales',
                                      'product_sales_tracker': 'invoices',
                                      'approved_invoices': 'approved_invoices',
                                      'match_invoices': 'match_invoices',
                                      'centers_system': 'agents',
                                      'employees': 'profiles',
                                      'attendance': 'attendance',
                                      'commissions': 'approved_invoices',
                                      'points': 'deferred_points',
                                      'daily_closings': 'daily_closings',
                                      'users': 'profiles',
                                      'accounts': 'expenses',
                                      'complaints': 'user_feedback',
                                      'company_letters': 'company_letters'
                                    };
                                    
                                    if (tableMap[item.id]) {
                                      if (tableMap[item.id] === 'daily_closings' || tableMap[item.id] === 'expenses') {
                                        fetchData(true);
                                      } else {
                                        fetchData(true, tableMap[item.id]);
                                      }
                                    }
                                  }} 
                                  className={({ isActive }) => `w-full flex items-center justify-between px-4 py-2.5 rounded-xl transition-all duration-200 group/item ${
                                    isActive 
                                      ? 'bg-primary-50 text-primary-700 shadow-sm shadow-primary-100/50' 
                                      : 'text-slate-400 hover:text-slate-700 hover:bg-slate-50'
                                  }`}
                                >
                                  {({ isActive }) => (
                                    <>
                                      <div className="flex items-center gap-3">
                                        <item.icon size={16} strokeWidth={isActive ? 2.5 : 1.5} className={isActive ? 'text-primary-600' : 'text-slate-300 group-hover/item:text-slate-500'} />
                                        <span className={`font-bold text-[12px] ${isActive ? 'text-slate-900' : ''}`}>{item.label}</span>
                                      </div>
                                      
                                      {isPoints && totalDeferredPointsValue > 0 && (
                                        <span className="px-2 py-0.5 bg-amber-500/10 text-amber-600 rounded-lg text-[9px] font-black">
                                          {totalDeferredPointsValue.toLocaleString()}
                                        </span>
                                      )}
                                    </>
                                  )}
                                </NavLink>
                              </li>
                            );
                          })}
                        </motion.ul>
                      )}
                    </AnimatePresence>
                  </div>
                );
              })}
            </div>

            {/* Robot Assistant Animation */}
            <AnimatePresence mode="wait">
              {expandedCategory === null && (
                <motion.div
                  key="robot-assistant"
                  initial={{ opacity: 0, scale: 0.8, y: 30 }}
                  animate={{ opacity: 1, scale: 1, y: 0 }}
                  exit={{ opacity: 0, scale: 0.8, y: 20 }}
                  transition={{ duration: 0.6, type: "spring", bounce: 0.4 }}
                  className="mt-8 flex flex-col items-center justify-center cursor-pointer group/robot"
                  onClick={() => setIsChatOpen(true)}
                >
                  <motion.div
                    animate={{ 
                      y: [0, -12, 0],
                      rotate: [-2, 2, -2]
                    }}
                    transition={{ 
                      duration: 4, 
                      repeat: Infinity, 
                      ease: "easeInOut" 
                    }}
                    className="relative"
                  >
                    <img 
                      src={systemSettings.robot_image_url || "https://storage.googleapis.com/test-media-gen/cbe8cd82-3d84-4861-a4b5-68936ef49eee.webp"} 
                      alt="نظام رائد الخير AI"
                      referrerPolicy="no-referrer"
                      style={{ 
                        width: `${(systemSettings.robot_size || 192) * 1.3}px`,
                        transform: `translate(${systemSettings.robot_x || 0}px, ${systemSettings.robot_y || 0}px)`,
                      }}
                      className="h-auto drop-shadow-2xl relative z-10 transition-all duration-500 group-hover/robot:scale-110"
                      onError={(e) => {
                        // Fallback to a stylised icon if image fails
                        e.currentTarget.style.display = 'none';
                        const parent = e.currentTarget.parentElement;
                        if (parent) {
                          const fallbackContainer = document.createElement('div');
                          fallbackContainer.className = 'w-32 h-32 bg-slate-900 rounded-full flex items-center justify-center shadow-2xl border-4 border-primary-500/30';
                          fallbackContainer.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 8V4H8"/><rect width="16" height="12" x="4" y="8" rx="2"/><path d="M2 14h2"/><path d="M20 14h2"/><path d="M15 13v2"/><path d="M9 13v2"/></svg>`;
                          parent.appendChild(fallbackContainer);
                        }
                      }}
                    />
                  </motion.div>
                  
                  <motion.div 
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.5 }}
                    className="mt-6 text-center space-y-2"
                  >
                    <div className="px-4 py-1.5 bg-slate-900/5 rounded-full border border-slate-200 shadow-sm inline-block group-hover/robot:bg-primary-500 group-hover/robot:text-white transition-colors">
                      <p className="text-[11px] font-black uppercase tracking-[0.15em]">مساعد رائد الخير الذكي</p>
                    </div>
                    
                    <div className="flex items-center justify-center gap-2">
                      <span className="relative flex h-2 w-2">
                        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
                        <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500"></span>
                      </span>
                      <span className="text-[10px] font-black text-emerald-600 uppercase tracking-widest bg-emerald-50 border border-emerald-100 px-2 py-0.5 rounded-md">اسألني أي شيء</span>
                    </div>
                  </motion.div>
                </motion.div>
              )}
            </AnimatePresence>
          </nav>

          <div className="p-6 mt-auto border-t border-slate-100 bg-white/50">
            <div className="flex flex-col items-center justify-center space-y-1 opacity-40 hover:opacity-100 transition-opacity duration-500">
                <p className="text-[10px] font-black text-slate-800 tracking-widest uppercase">رائد الخير 2026</p>
                <div className="h-0.5 w-4 bg-primary-500 rounded-full"></div>
                <p className="text-[8px] font-bold text-slate-400 tracking-[0.2em] uppercase">Enterprise Edition</p>
            </div>
          </div>
        </div>
      </aside>

      <AIChatDialog isOpen={isChatOpen} onClose={() => setIsChatOpen(false)} />
    </>
  );
};

export default Sidebar;
